import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

import '../layout3/style/pt-menu.less';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';

let isScrolling = false;

@inject('portalThemeStore')
@observer
class E9NavMenu extends React.Component {
  constructor(props) {
    super(props);
    this.getNavMenu = this.getNavMenu.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onTitleClick = this.onTitleClick.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getData = this.getData.bind(this);
    this.setHeight = this.setHeight.bind(this);
  }

  componentDidMount() {
    const $menu = $('.e9navbar-container .pt-menu-root');
    const containerWidth = $(window).width() - 72;
    const contentWidth = $menu.width();

    if (contentWidth > containerWidth) {
      this.refs.prev.style.display = 'block';
      this.refs.next.style.display = 'block';
    }
  }

  render() {
    const { portalThemeStore } = this.props;
    const { themeInfo, frontEndMenu = [], leftMenuObj } = portalThemeStore;

    const { themeData = {} } = themeInfo;
    const { styleConfig = {} } = themeData;
    const { leftmenu = {} } = styleConfig;
    const fontSize = parseInt(leftmenu.titleFontSize || '12px');

    const { leftMenuSelected = {} } = leftMenuObj;
    const _frontEndMenu = toJS(frontEndMenu);
    const _leftMenuSelected = toJS(leftMenuSelected);
    const _selectedKeys = [_leftMenuSelected.id || ''];

    return (
      <div className={`e9navbar-container wea-f${fontSize}`}>
        <span ref="prev" className="e9navbar-prev" onClick={this.onPrev}>
          <span className="ant-tabs-tab-prev-icon" />
        </span>
        <Menu
          ecId={`${(this && this.props && this.props.ecId) || ''}_Menu@mliyu9`}
          ref={(ref) => (this.menuRef = ref)}
          mode="horizontal"
          prefixCls="pt-menu"
          openAnimation="zoom"
          subMenuCloseDelay={0.2}
          selectedKeys={_selectedKeys}
          onClick={this.onSelect}
          onOpenChange={this.setHeight}
        >
          {this.getNavMenu(_frontEndMenu, 1, fontSize, _selectedKeys[0])}
        </Menu>
        <span ref="next" className="e9navbar-next" onClick={this.onNext}>
          <span className="ant-tabs-tab-next-icon" />
        </span>
      </div>
    );
  }

  getNavMenu(data, level, fontSize, _selectedKeys) {
    const { portalThemeStore } = this.props;
    const { translatepage } = portalThemeStore;

    return data.map((item) => {
      const name = translatepage == '1' ? (item.fname ? item.fname : item.name) : item.name;

      if (item.child && item.child.length) {
        return (
          <SubMenu
            ecId={`${(this && this.props && this.props.ecId) || ''}_SubMenu@n75bka@${item.id}`}
            key={item.id}
            popupClassName={`e9navbar-sub-container wea-f${fontSize}`}
            className={_selectedKeys == item.id ? 'e9navbar-e9submenu-selected' : 'e9navbar-e9submenu-unselected'}
            title={
              level == 1 ? (
                <span className="e9navbar-top-menu-icon">
                  {item.iconType == '2' && item.iconImgSrc ? (
                    <img src={item.iconImgSrc} alt="" />
                  ) : item.icon ? (
                    <i className={item.icon} />
                  ) : (
                    <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`} />
                  )}
                  <span title={name}>{name}</span>
                </span>
              ) : (
                <span title={name}>{name}</span>
              )
            }
            data={item}
            onTitleClick={() => this.onTitleClick(item)}
          >
            {this.getNavMenu(item.child, level + 1, fontSize, _selectedKeys)}
          </SubMenu>
        );
      }

      return (
        <MenuItem ecId={`${(this && this.props && this.props.ecId) || ''}_MenuItem@a2m3hp@${item.id}`} key={item.id} data={item}>
          {level == 1 ? (
            <div className="pt-menu-item-title">
              <span className="e9navbar-top-menu-icon">
                {item.iconType == '2' && item.iconImgSrc ? (
                  <img src={item.iconImgSrc} alt="" />
                ) : item.icon ? (
                  <i className={item.icon} />
                ) : (
                  <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`} />
                )}
                <span title={name}>{name}</span>
              </span>
            </div>
          ) : (
            <span title={name}>{name}</span>
          )}
        </MenuItem>
      );
    });
  }

  setHeight() {
    if ($('.pt-menu-submenu-popup ul').length > 0) {
      $('.pt-menu-submenu-popup ul').css({ 'max-height': $(window).height() - 150, 'overflow-x': 'hidden', 'overflow-y': 'auto' });
    }
  }

  onNext() {
    const $menu = $('.e9navbar-container .pt-menu-root');
    const containerWidth = $(window).width() - 72;
    const contentWidth = $menu.width();
    const contentLeft = $menu.position().left;
    if (!isScrolling && contentWidth + contentLeft > containerWidth) {
      isScrolling = true;
      $menu.animate({ left: contentLeft - containerWidth / 2 }, 300, () => {
        isScrolling = false;
      });
    }
  }

  onPrev() {
    const $menu = $('.e9navbar-container .pt-menu-root');
    const containerWidth = $(window).width() - 72;
    // const contentWidth = $menu.width();
    const contentLeft = $menu.position().left;
    if (!isScrolling && contentLeft < 0) {
      isScrolling = true;
      let leftValue = contentLeft * 2 + containerWidth;
      if (leftValue <= 0) {
        $menu.animate({ left: contentLeft + containerWidth / 2 }, 300, () => {
          isScrolling = false;
        });
      } else {
        $menu.animate({ left: 0 }, 300, () => {
          isScrolling = false;
        });
      }
    }
  }

  onTitleClick(data) {
    const { portalThemeStore } = this.props;

    if (data.mobxrouteurl || data.fullrouteurl || (data.url && data.url != 'javascript:void(0);')) {
      portalThemeStore.onLeftMenuSelectedChange(data);
      portalThemeStore.onLoadMain(data);
    } else if (data.child && data.child.length) {
      let item = data.child[0];

      if (data.url != '') {
        for (;;) {
          if (item.mobxrouteurl || item.fullrouteurl || (item.url && item.url != 'javascript:void(0);')) {
            portalThemeStore.onLeftMenuSelectedChange(item);
            portalThemeStore.onLoadMain(item);
            break;
          } else if (item.child && item.child.length) {
            item = item.child[0];
          } else {
            break;
          }
        }
      } else {
        // 当前菜单不存在url，获取当前菜单的下级菜单url
        this.getData(item, 1);
      }
    }
  }
  getData(data, level) {
    if (data.mobxrouteurl || data.fullrouteurl || (data.url && data.url != 'javascript:void(0);')) {
      const { portalThemeStore } = this.props;
      portalThemeStore.onLeftMenuSelectedChange(data);
      portalThemeStore.onLoadMain(data);
    } else if (data.child && data.child.length) {
      const item = data.child[0];
      this.getData(item, level + 1);
    }
  }

  onSelect(e) {
    const { data } = e.item.props;

    const { portalThemeStore } = this.props;
    portalThemeStore.onLeftMenuSelectedChange(data);
    portalThemeStore.onLoadMain(data);

    if (this.menuRef && this.menuRef.store) {
      this.menuRef.store.setState({ openKeys: [] });
    }
  }
}

export default E9NavMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout2/E9NavMenu.js